export default "__VITE_ASSET__cfd05f20__"